import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { IEntityApiService } from 'app/projects/entity/src/lib/interfaces/entity.service.interface';
import { EntityService } from 'app/projects/entity/src/lib/services/entity.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { IFinalGradeExtendedQuery } from '../interfaces/final-grade-extended.query.interface';
import { IFinalGradeQuery } from '../interfaces/final-grade.query.interface';
import { IParticipantGradesQuery } from '../interfaces/participant-grades.query';
import { FinalGradeExtended } from '../models/final-grade-extended.model';
import { FinalGradeCommand } from '../models/final-grade.command.model';
import { FinalGrade } from '../models/final-grade.model';

@Injectable()
export class FinalGradeApiService extends EntityService<IFinalGradeQuery, FinalGradeCommand> implements IEntityApiService<FinalGrade> {
    constructor(http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) environment: IEnvironment) {
        super(http, environment.apiUrl, 'final-grades');
    }

    getAll(): Observable<FinalGrade[]> {
        return this.http.get<IFinalGradeQuery[]>(`${this.apiUrl}/final-grades/participant`).pipe(map((queries) => queries.map((query) => new FinalGrade(query))));
    }

    create(entity: FinalGrade): Observable<FinalGrade> {
        const data = new FinalGradeCommand(entity);

        return this._create(data).pipe(map((query) => new FinalGrade(query)));
    }

    read(id: string): Observable<FinalGrade> {
        return this._read(id).pipe(map((query) => new FinalGrade(query)));
    }

    readByModuleId(moduleId: string): Observable<FinalGrade> {
        return this.http.get<IFinalGradeQuery>(`${this.apiUrl}/modules/${moduleId}/final-grade/participant`).pipe(map((query) => new FinalGrade(query)));
    }

    update(entity: FinalGrade): Observable<FinalGrade> {
        const data = new FinalGradeCommand(entity);

        return this._update(entity.id, data).pipe(map((query) => new FinalGrade(query)));
    }

    bulkUpdateStatus(entityIds: string[], status: string): Observable<FinalGrade[]> {
        return this.http
            .post<IFinalGradeQuery[]>(`${this.apiUrl}/${this.entities}/status/bulk`, {
                ids: entityIds,
                status: status,
            })
            .pipe(map((queries) => queries.map((query) => new FinalGrade(query))));
    }

    bulkUpdate(entities: FinalGradeCommand[]): Observable<FinalGrade[]> {
        return this.http.patch<IFinalGradeQuery[]>(`${this.apiUrl}/${this.entities}`, entities).pipe(map((queries) => queries.map((query) => new FinalGrade(query))));
    }

    delete(id: string): Observable<any> {
        return this._delete(id);
    }

    getUserFinalGrades(): Observable<FinalGradeExtended[]> {
        return this.http
            .get<IFinalGradeExtendedQuery[]>(`${this.apiUrl}/${this.entities}/participant`)
            .pipe(map((queries) => queries.map((query) => new FinalGradeExtended(query))));
    }

    getGradesForParticipant(moduleId: string): Observable<IParticipantGradesQuery> {
        return this.http.get<IParticipantGradesQuery>(`${this.apiUrl}/modules/${moduleId}/grades/participant`);
    }
}
